import { isNil } from 'ramda'
import { useLocation } from 'react-router-dom'

const useQuery = (name: string): string | undefined => {
    const value = new URLSearchParams(useLocation().search).get(name)
    return isNil(value) ? undefined : value
}

export default useQuery
